module.exports = __webpack_public_path__ + "img/ss09.48c34110.jpg";